import api from "../axios";
import Api from "../Api";


// ============================================================
// GET CLIENT LIST
// GET /client-information
// ============================================================

export async function ClientInformationFindAll({
  page = 1,
  limit = 10,
  search = "",
  place = "",
  country = "",
  status = "",
} = {}) {
  try {
    const response = await api.get(
      `${Api.request.URL}/client-information`,
      {
        params: {
          page,
          limit,
          search,
          place,
          country,
          status,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationFindAll Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to load customer list.",
      }
    );
  }
}


// ============================================================
// GET SINGLE CLIENT
// GET /client-information/:id
// ============================================================

export async function ClientInformationFindOne(
  id
) {
  try {
    const response = await api.get(
      `${Api.request.URL}/client-information/${id}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationFindOne Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to load customer.",
      }
    );
  }
}


// ============================================================
// CREATE CLIENT
// POST /client-information
// ============================================================

export async function ClientInformationCreate(
  data
) {
  try {
    const response = await api.post(
      `${Api.request.URL}/client-information`,
      data
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationCreate Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to create customer.",
      }
    );
  }
}


// ============================================================
// UPDATE CLIENT
// PUT /client-information/:id
// ============================================================

export async function ClientInformationUpdate(
  id,
  data
) {
  try {
    const response = await api.put(
      `${Api.request.URL}/client-information/${id}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationUpdate Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to update customer.",
      }
    );
  }
}


// ============================================================
// DELETE / DEACTIVATE CLIENT
// DELETE /client-information/:id
// ============================================================

export async function ClientInformationDelete(
  id
) {
  try {
    const response = await api.delete(
      `${Api.request.URL}/client-information/${id}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationDelete Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to delete customer.",
      }
    );
  }
}


// ============================================================
// GET LOCATIONS
// GET /client-information/locations
// ============================================================

export async function ClientInformationLocations() {
  try {
    const response = await api.get(
      `${Api.request.URL}/client-information/locations`
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationLocations Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to load locations.",
      }
    );
  }
}


// ============================================================
// GET CUSTOMER LIST FOR PRINTING
//
// This is NOT PDF.
// Returns the selected location's customers.
// ============================================================

export async function ClientInformationPrintList(
  place
) {
  try {
    const response = await api.get(
      `${Api.request.URL}/client-information/print`,
      {
        params: {
          place,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationPrintList Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to load customer print list.",
      }
    );
  }
}


// ============================================================
// DOWNLOAD EXCEL TEMPLATE
// GET /client-information/template
// ============================================================

export async function ClientInformationTemplate() {
  try {
    const response = await api.get(
      `${Api.request.URL}/client-information/template`,
      {
        responseType: "blob",
      }
    );

    return response;
  } catch (error) {
    console.error(
      "ClientInformationTemplate Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to download template.",
      }
    );
  }
}


// ============================================================
// UPLOAD CLIENT EXCEL
// POST /client-information/upload
// ============================================================

export async function ClientInformationUpload(
  formData
) {
  try {
    const response = await api.post(
      `${Api.request.URL}/client-information/upload`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "ClientInformationUpload Error:",
      error
    );

    return (
      error?.response?.data || {
        S: false,
        success: false,
        errors:
          error?.message ||
          "Unable to upload customer file.",
      }
    );
  }
}